<template>
  <v-dialog
    persistent
    v-model="dialogLogin"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn class="d-flex flex-row-reverse mr-3" text icon @click="dialogLogin = true">
        <v-icon size="30">mdi-login</v-icon>
      </v-btn>
    </template>
    <v-card class>
      <v-card class="mx-auto pt-6 pt-sm-12 transparent" max-width="600" flat>
        <v-card-title class="pa-0">
          <v-btn
            width="40"
            height="40"
            elevation="3"
            icon
            color="#ffffff"
            style="background-color:white;"
            small
            absolute
            left
            top
            @click="back"
          >
            <v-icon class="black--text ma-auto">mdi-arrow-left</v-icon>
          </v-btn>
        </v-card-title>

        <v-btn
          v-if="!forced"
          width="40"
          height="40"
          elevation="3"
          icon
          color="#ffffff"
          style="background-color:white;"
          small
          absolute
          right
          top
          @click="dialogLogin = false"
        >
          <v-icon class="black--text ma-auto">mdi-close</v-icon>
        </v-btn>
        <v-card-text class="d-flex justify-center">
          <v-img
            class="pa-0 my-6 my-sm-12"
            :src="getLogo()"
            :lazy-src="getLogo()"
            contain
            :height="$vuetify.breakpoint.mdAndDown ? '28' : '36'"
            width="130"
          ></v-img>
        </v-card-text>
        <v-card-text>
          <loginForm />
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapActions, mapState } from "vuex";
import loginForm from "@/components/loginForm.vue";
export default {
  name: "loginDialog",
  components: {
    loginForm
  },
  props: {
    forced: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      negocioPropio: state => state.propio.negocioPropio,
      modoGeneral: state => state.app.modoGeneral
    }),

    dialogLogin: {
      get() {
        return this.$store.state.app.dialogLogin;
      },
      set(value) {
        this.$store.commit("app/setDialogLogin", value);
      }
    },
    loginCaptchaActivo: {
      get() {
        return this.$store.state.auth.loginCaptchaActivo;
      },
      set(value) {
        this.$store.commit("auth/setLoginCaptchaActivo", value);
      }
    }
  },
  methods: {
    ...mapActions({
      backAction: "app/backAction"
    }),
    getLogo() {
      let _vue = this;
      if (this.modoGeneral == "propio") {
        return "/" + this.negocioPropio + "/logo.png";
      } else {
        return "/img/logoFunEats.svg";
      }
    },
    back() {
      this.backAction();
      this.dialogLogin = false;
    }
  }
};
</script>

<style scoped>
.border {
  border: 1px solid #000;
}
</style>